import CryptoJS from "crypto-js";
import { SecretKeys } from "../Constants/SecretKey";
import { decryptFunction } from "./SessionService";
import { alertService } from "../UI Components/Services/alertService";

export const validateNegativeNumbers = (value: any, langData?: any) => {
  let error = ""
  if (parseInt(value) <= 0) {
    error = langData?.NegativeNumbersError ? langData?.NegativeNumbersError : "Enter value greater than 0";
  }
  return error;
}

export const getURLDataMethod = () => {
  let defUrl: any = window.location.href;
  let url_complete_data: any = defUrl.split('deviceConfig/')?.[1];
  if (url_complete_data) {
    let URL_Data = url_complete_data?.split('&');
    let details: any = {
      firmware_version: URL_Data?.[0],
      device_type: URL_Data?.[1],
      device_id: URL_Data?.[2],
    };
    if (!decryptFunction("activeSession")?.["hasURLDetails"]) {
      let secretKey: any = SecretKeys.cryptoSecretKey;
      let tempSession: any = {
        "currentSession": decryptFunction("activeSession")?.["currentSession"],
        "hasURLDetails": true,
      }
      localStorage.setItem('activeSession', CryptoJS.AES.encrypt(JSON.stringify(tempSession), secretKey).toString())
    }
    return details;
  }
  else {
    let secretKey: any = SecretKeys.cryptoSecretKey;
    let tempSession: any = {
      "currentSession": decryptFunction("activeSession")?.["currentSession"],
      "hasURLDetails": false,
    }
    localStorage.setItem('activeSession', CryptoJS.AES.encrypt(JSON.stringify(tempSession), secretKey).toString())
    return null;
  }
}

export const endSession = () => {
  let secretKey: any = SecretKeys.cryptoSecretKey;
  // let backupURL: any = localStorage.getItem('url');
  localStorage.clear();
  let tempSession: any = {
    "currentSession": false,
    "hasURLDetails": getURLDataMethod() ? true : false,
  }
  localStorage.setItem('activeSession', CryptoJS.AES.encrypt(JSON.stringify(tempSession), secretKey).toString())
  // localStorage.setItem('url', backupURL)
  window.location.reload();
}

export const noAccessMessage = (message: any) => {
  alertService?.serviceErrorMessage(message)
}

// export const logOutEndSession = () => {

// }


const getFirstThreeCharacters = (username: any) => {
  try {
    let three = '';
    let len = username.length;
    if (len <= 3) {
      three = username + ('a'.repeat(3 - len));
    } else {
      three = username.slice(0, 3);
    }
    return three;
  } catch (e) {
    console.error(e);
    return '';
  }
}

export const encrypt = (encData: any) => {
  const key = getSessionKey();
  encData = JSON.stringify(encData);
  const iv = CryptoJS.lib.WordArray.random(16);
  const encrypted = CryptoJS.AES.encrypt(encData, key, {
    iv,
  });
  return iv.concat(encrypted.ciphertext).toString(CryptoJS.enc.Base64);
}

const getSessionKey = () => {
  const session_id = returnK();
  const parsed_session_id = CryptoJS.enc.Utf8.parse(session_id);
  return parsed_session_id;
}

let waste = {
  k: '',
  li: '',
  Lens: '',
  KLiL: '',
  e: '',
  nsK: '',
  L: '',
};

const returnK = () => {
  let k = '';
  // tslint:disable-next-line: forin
  for (let prop in waste) {
    k += prop;
  }
  return k;
}